import { render, staticRenderFns } from "./PrintMailDataTable.vue?vue&type=template&id=031789d8&scoped=true"
import script from "./PrintMailDataTable.vue?vue&type=script&lang=js"
export * from "./PrintMailDataTable.vue?vue&type=script&lang=js"
import style0 from "./PrintMailDataTable.vue?vue&type=style&index=0&id=031789d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031789d8",
  null
  
)

export default component.exports